'use client';

import { getQueryClient } from '@/app/api/_client';
import { QueryClientProvider as TanstackQueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

type QueryClientProviderProps = {
    children: React.ReactNode;
};

export const QueryClientProvider = ({ children }: QueryClientProviderProps) => {
    const queryClient = getQueryClient();

    return (
        <TanstackQueryClientProvider client={queryClient}>
            {children}
            <ReactQueryDevtools initialIsOpen={false} />
        </TanstackQueryClientProvider>
    );
};
